/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var station_pb = require('./station_pb.js');
goog.exportSymbol('proto.fleet.AutocompletePrediction', null, global);
goog.exportSymbol('proto.fleet.AutocompletePredictionsRequest', null, global);
goog.exportSymbol('proto.fleet.AutocompletePredictionsResponse', null, global);
goog.exportSymbol('proto.fleet.DirectionsLeg', null, global);
goog.exportSymbol('proto.fleet.DirectionsRequest', null, global);
goog.exportSymbol('proto.fleet.DirectionsResponse', null, global);
goog.exportSymbol('proto.fleet.DirectionsRoute', null, global);
goog.exportSymbol('proto.fleet.DirectionsStep', null, global);
goog.exportSymbol('proto.fleet.Distance', null, global);
goog.exportSymbol('proto.fleet.Duration', null, global);
goog.exportSymbol('proto.fleet.LatLngBounds', null, global);
goog.exportSymbol('proto.fleet.LatLngLiteral', null, global);
goog.exportSymbol('proto.fleet.PlaceDetailsFromLatLngRequest', null, global);
goog.exportSymbol('proto.fleet.PlaceDetailsRequest', null, global);
goog.exportSymbol('proto.fleet.PlaceDetailsResponse', null, global);
goog.exportSymbol('proto.fleet.PlaceGeometry', null, global);
goog.exportSymbol('proto.fleet.PlaceResult', null, global);
goog.exportSymbol('proto.fleet.TravelMode', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AutocompletePrediction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.AutocompletePrediction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AutocompletePrediction.displayName = 'proto.fleet.AutocompletePrediction';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AutocompletePrediction.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AutocompletePrediction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AutocompletePrediction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AutocompletePrediction.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    placeId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AutocompletePrediction}
 */
proto.fleet.AutocompletePrediction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AutocompletePrediction;
  return proto.fleet.AutocompletePrediction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AutocompletePrediction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AutocompletePrediction}
 */
proto.fleet.AutocompletePrediction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AutocompletePrediction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AutocompletePrediction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AutocompletePrediction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AutocompletePrediction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.fleet.AutocompletePrediction.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.AutocompletePrediction.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string place_id = 2;
 * @return {string}
 */
proto.fleet.AutocompletePrediction.prototype.getPlaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.AutocompletePrediction.prototype.setPlaceId = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.LatLngLiteral = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.LatLngLiteral, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.LatLngLiteral.displayName = 'proto.fleet.LatLngLiteral';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.LatLngLiteral.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.LatLngLiteral.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.LatLngLiteral} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.LatLngLiteral.toObject = function(includeInstance, msg) {
  var f, obj = {
    lat: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    lng: +jspb.Message.getFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.LatLngLiteral}
 */
proto.fleet.LatLngLiteral.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.LatLngLiteral;
  return proto.fleet.LatLngLiteral.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.LatLngLiteral} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.LatLngLiteral}
 */
proto.fleet.LatLngLiteral.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLat(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLng(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.LatLngLiteral.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.LatLngLiteral.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.LatLngLiteral} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.LatLngLiteral.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLat();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLng();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double lat = 1;
 * @return {number}
 */
proto.fleet.LatLngLiteral.prototype.getLat = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.fleet.LatLngLiteral.prototype.setLat = function(value) {
  jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double lng = 2;
 * @return {number}
 */
proto.fleet.LatLngLiteral.prototype.getLng = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.fleet.LatLngLiteral.prototype.setLng = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.LatLngBounds = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.LatLngBounds, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.LatLngBounds.displayName = 'proto.fleet.LatLngBounds';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.LatLngBounds.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.LatLngBounds.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.LatLngBounds} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.LatLngBounds.toObject = function(includeInstance, msg) {
  var f, obj = {
    northeast: (f = msg.getNortheast()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    southwest: (f = msg.getSouthwest()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.LatLngBounds}
 */
proto.fleet.LatLngBounds.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.LatLngBounds;
  return proto.fleet.LatLngBounds.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.LatLngBounds} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.LatLngBounds}
 */
proto.fleet.LatLngBounds.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setNortheast(value);
      break;
    case 2:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setSouthwest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.LatLngBounds.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.LatLngBounds.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.LatLngBounds} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.LatLngBounds.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNortheast();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getSouthwest();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
};


/**
 * optional LatLngLiteral northeast = 1;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.LatLngBounds.prototype.getNortheast = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 1));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.LatLngBounds.prototype.setNortheast = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.LatLngBounds.prototype.clearNortheast = function() {
  this.setNortheast(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.LatLngBounds.prototype.hasNortheast = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LatLngLiteral southwest = 2;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.LatLngBounds.prototype.getSouthwest = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 2));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.LatLngBounds.prototype.setSouthwest = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.LatLngBounds.prototype.clearSouthwest = function() {
  this.setSouthwest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.LatLngBounds.prototype.hasSouthwest = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.PlaceGeometry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.PlaceGeometry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.PlaceGeometry.displayName = 'proto.fleet.PlaceGeometry';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.PlaceGeometry.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.PlaceGeometry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.PlaceGeometry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceGeometry.toObject = function(includeInstance, msg) {
  var f, obj = {
    location: (f = msg.getLocation()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    viewport: (f = msg.getViewport()) && proto.fleet.LatLngBounds.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.PlaceGeometry}
 */
proto.fleet.PlaceGeometry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.PlaceGeometry;
  return proto.fleet.PlaceGeometry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.PlaceGeometry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.PlaceGeometry}
 */
proto.fleet.PlaceGeometry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    case 2:
      var value = new proto.fleet.LatLngBounds;
      reader.readMessage(value,proto.fleet.LatLngBounds.deserializeBinaryFromReader);
      msg.setViewport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.PlaceGeometry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.PlaceGeometry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.PlaceGeometry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceGeometry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getViewport();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.LatLngBounds.serializeBinaryToWriter
    );
  }
};


/**
 * optional LatLngLiteral location = 1;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.PlaceGeometry.prototype.getLocation = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 1));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.PlaceGeometry.prototype.setLocation = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.PlaceGeometry.prototype.clearLocation = function() {
  this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PlaceGeometry.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LatLngBounds viewport = 2;
 * @return {?proto.fleet.LatLngBounds}
 */
proto.fleet.PlaceGeometry.prototype.getViewport = function() {
  return /** @type{?proto.fleet.LatLngBounds} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngBounds, 2));
};


/** @param {?proto.fleet.LatLngBounds|undefined} value */
proto.fleet.PlaceGeometry.prototype.setViewport = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.PlaceGeometry.prototype.clearViewport = function() {
  this.setViewport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PlaceGeometry.prototype.hasViewport = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.PlaceResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.PlaceResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.PlaceResult.displayName = 'proto.fleet.PlaceResult';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.PlaceResult.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.PlaceResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.PlaceResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    formattedAddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    geometry: (f = msg.getGeometry()) && proto.fleet.PlaceGeometry.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    placeId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.PlaceResult}
 */
proto.fleet.PlaceResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.PlaceResult;
  return proto.fleet.PlaceResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.PlaceResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.PlaceResult}
 */
proto.fleet.PlaceResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormattedAddress(value);
      break;
    case 2:
      var value = new proto.fleet.PlaceGeometry;
      reader.readMessage(value,proto.fleet.PlaceGeometry.deserializeBinaryFromReader);
      msg.setGeometry(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.PlaceResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.PlaceResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.PlaceResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFormattedAddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGeometry();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.PlaceGeometry.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlaceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string formatted_address = 1;
 * @return {string}
 */
proto.fleet.PlaceResult.prototype.getFormattedAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.PlaceResult.prototype.setFormattedAddress = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PlaceGeometry geometry = 2;
 * @return {?proto.fleet.PlaceGeometry}
 */
proto.fleet.PlaceResult.prototype.getGeometry = function() {
  return /** @type{?proto.fleet.PlaceGeometry} */ (
    jspb.Message.getWrapperField(this, proto.fleet.PlaceGeometry, 2));
};


/** @param {?proto.fleet.PlaceGeometry|undefined} value */
proto.fleet.PlaceResult.prototype.setGeometry = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.PlaceResult.prototype.clearGeometry = function() {
  this.setGeometry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PlaceResult.prototype.hasGeometry = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.fleet.PlaceResult.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.PlaceResult.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string place_id = 4;
 * @return {string}
 */
proto.fleet.PlaceResult.prototype.getPlaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.PlaceResult.prototype.setPlaceId = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AutocompletePredictionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.AutocompletePredictionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AutocompletePredictionsRequest.displayName = 'proto.fleet.AutocompletePredictionsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AutocompletePredictionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AutocompletePredictionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AutocompletePredictionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    entry: jspb.Message.getFieldWithDefault(msg, 1, ""),
    opAreaId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sessionToken: jspb.Message.getFieldWithDefault(msg, 3, ""),
    language: jspb.Message.getFieldWithDefault(msg, 4, ""),
    radius: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AutocompletePredictionsRequest}
 */
proto.fleet.AutocompletePredictionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AutocompletePredictionsRequest;
  return proto.fleet.AutocompletePredictionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AutocompletePredictionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AutocompletePredictionsRequest}
 */
proto.fleet.AutocompletePredictionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEntry(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOpAreaId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionToken(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRadius(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AutocompletePredictionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AutocompletePredictionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AutocompletePredictionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntry();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOpAreaId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRadius();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string entry = 1;
 * @return {string}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.getEntry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.AutocompletePredictionsRequest.prototype.setEntry = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 op_area_id = 2;
 * @return {number}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.getOpAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.fleet.AutocompletePredictionsRequest.prototype.setOpAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string session_token = 3;
 * @return {string}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.AutocompletePredictionsRequest.prototype.setSessionToken = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string language = 4;
 * @return {string}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.AutocompletePredictionsRequest.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 radius = 5;
 * @return {number}
 */
proto.fleet.AutocompletePredictionsRequest.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.fleet.AutocompletePredictionsRequest.prototype.setRadius = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.AutocompletePredictionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.AutocompletePredictionsResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.AutocompletePredictionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.AutocompletePredictionsResponse.displayName = 'proto.fleet.AutocompletePredictionsResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.AutocompletePredictionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.AutocompletePredictionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.AutocompletePredictionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.AutocompletePredictionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AutocompletePredictionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    predictionsList: jspb.Message.toObjectList(msg.getPredictionsList(),
    proto.fleet.AutocompletePrediction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.AutocompletePredictionsResponse}
 */
proto.fleet.AutocompletePredictionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.AutocompletePredictionsResponse;
  return proto.fleet.AutocompletePredictionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.AutocompletePredictionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.AutocompletePredictionsResponse}
 */
proto.fleet.AutocompletePredictionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.AutocompletePrediction;
      reader.readMessage(value,proto.fleet.AutocompletePrediction.deserializeBinaryFromReader);
      msg.addPredictions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.AutocompletePredictionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.AutocompletePredictionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.AutocompletePredictionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.AutocompletePredictionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPredictionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.AutocompletePrediction.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AutocompletePrediction predictions = 1;
 * @return {!Array<!proto.fleet.AutocompletePrediction>}
 */
proto.fleet.AutocompletePredictionsResponse.prototype.getPredictionsList = function() {
  return /** @type{!Array<!proto.fleet.AutocompletePrediction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.AutocompletePrediction, 1));
};


/** @param {!Array<!proto.fleet.AutocompletePrediction>} value */
proto.fleet.AutocompletePredictionsResponse.prototype.setPredictionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.AutocompletePrediction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.AutocompletePrediction}
 */
proto.fleet.AutocompletePredictionsResponse.prototype.addPredictions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.AutocompletePrediction, opt_index);
};


proto.fleet.AutocompletePredictionsResponse.prototype.clearPredictionsList = function() {
  this.setPredictionsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.PlaceDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.PlaceDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.PlaceDetailsRequest.displayName = 'proto.fleet.PlaceDetailsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.PlaceDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.PlaceDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.PlaceDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    placeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    language: jspb.Message.getFieldWithDefault(msg, 3, ""),
    opAreaId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.PlaceDetailsRequest}
 */
proto.fleet.PlaceDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.PlaceDetailsRequest;
  return proto.fleet.PlaceDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.PlaceDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.PlaceDetailsRequest}
 */
proto.fleet.PlaceDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOpAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.PlaceDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.PlaceDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.PlaceDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpAreaId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string place_id = 1;
 * @return {string}
 */
proto.fleet.PlaceDetailsRequest.prototype.getPlaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.PlaceDetailsRequest.prototype.setPlaceId = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string session_token = 2;
 * @return {string}
 */
proto.fleet.PlaceDetailsRequest.prototype.getSessionToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.PlaceDetailsRequest.prototype.setSessionToken = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string language = 3;
 * @return {string}
 */
proto.fleet.PlaceDetailsRequest.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.PlaceDetailsRequest.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 op_area_id = 4;
 * @return {number}
 */
proto.fleet.PlaceDetailsRequest.prototype.getOpAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.fleet.PlaceDetailsRequest.prototype.setOpAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.PlaceDetailsFromLatLngRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.PlaceDetailsFromLatLngRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.PlaceDetailsFromLatLngRequest.displayName = 'proto.fleet.PlaceDetailsFromLatLngRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.PlaceDetailsFromLatLngRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.PlaceDetailsFromLatLngRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceDetailsFromLatLngRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    latLng: (f = msg.getLatLng()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 2, ""),
    opAreaId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.PlaceDetailsFromLatLngRequest}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.PlaceDetailsFromLatLngRequest;
  return proto.fleet.PlaceDetailsFromLatLngRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.PlaceDetailsFromLatLngRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.PlaceDetailsFromLatLngRequest}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setLatLng(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOpAreaId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.PlaceDetailsFromLatLngRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.PlaceDetailsFromLatLngRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceDetailsFromLatLngRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatLng();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOpAreaId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional LatLngLiteral lat_lng = 1;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.getLatLng = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 1));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.setLatLng = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.PlaceDetailsFromLatLngRequest.prototype.clearLatLng = function() {
  this.setLatLng(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.hasLatLng = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string language = 2;
 * @return {string}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 op_area_id = 3;
 * @return {number}
 */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.getOpAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.fleet.PlaceDetailsFromLatLngRequest.prototype.setOpAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.PlaceDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.PlaceDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.PlaceDetailsResponse.displayName = 'proto.fleet.PlaceDetailsResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.PlaceDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.PlaceDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.PlaceDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    opAreaId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    placeResult: (f = msg.getPlaceResult()) && proto.fleet.PlaceResult.toObject(includeInstance, f),
    closestStation: (f = msg.getClosestStation()) && station_pb.Station.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.PlaceDetailsResponse}
 */
proto.fleet.PlaceDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.PlaceDetailsResponse;
  return proto.fleet.PlaceDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.PlaceDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.PlaceDetailsResponse}
 */
proto.fleet.PlaceDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOpAreaId(value);
      break;
    case 2:
      var value = new proto.fleet.PlaceResult;
      reader.readMessage(value,proto.fleet.PlaceResult.deserializeBinaryFromReader);
      msg.setPlaceResult(value);
      break;
    case 3:
      var value = new station_pb.Station;
      reader.readMessage(value,station_pb.Station.deserializeBinaryFromReader);
      msg.setClosestStation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.PlaceDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.PlaceDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.PlaceDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.PlaceDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpAreaId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPlaceResult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.PlaceResult.serializeBinaryToWriter
    );
  }
  f = message.getClosestStation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      station_pb.Station.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 op_area_id = 1;
 * @return {number}
 */
proto.fleet.PlaceDetailsResponse.prototype.getOpAreaId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.fleet.PlaceDetailsResponse.prototype.setOpAreaId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional PlaceResult place_result = 2;
 * @return {?proto.fleet.PlaceResult}
 */
proto.fleet.PlaceDetailsResponse.prototype.getPlaceResult = function() {
  return /** @type{?proto.fleet.PlaceResult} */ (
    jspb.Message.getWrapperField(this, proto.fleet.PlaceResult, 2));
};


/** @param {?proto.fleet.PlaceResult|undefined} value */
proto.fleet.PlaceDetailsResponse.prototype.setPlaceResult = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.PlaceDetailsResponse.prototype.clearPlaceResult = function() {
  this.setPlaceResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PlaceDetailsResponse.prototype.hasPlaceResult = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Station closest_station = 3;
 * @return {?proto.fleet.Station}
 */
proto.fleet.PlaceDetailsResponse.prototype.getClosestStation = function() {
  return /** @type{?proto.fleet.Station} */ (
    jspb.Message.getWrapperField(this, station_pb.Station, 3));
};


/** @param {?proto.fleet.Station|undefined} value */
proto.fleet.PlaceDetailsResponse.prototype.setClosestStation = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.fleet.PlaceDetailsResponse.prototype.clearClosestStation = function() {
  this.setClosestStation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.PlaceDetailsResponse.prototype.hasClosestStation = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.Distance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.Distance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.Distance.displayName = 'proto.fleet.Distance';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.Distance.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.Distance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.Distance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Distance.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: +jspb.Message.getFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.Distance}
 */
proto.fleet.Distance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.Distance;
  return proto.fleet.Distance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.Distance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.Distance}
 */
proto.fleet.Distance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.Distance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.Distance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.Distance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Distance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.fleet.Distance.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.Distance.prototype.setText = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.fleet.Distance.prototype.getValue = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.fleet.Distance.prototype.setValue = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.Duration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.Duration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.Duration.displayName = 'proto.fleet.Duration';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.Duration.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.Duration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.Duration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Duration.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: +jspb.Message.getFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.Duration}
 */
proto.fleet.Duration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.Duration;
  return proto.fleet.Duration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.Duration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.Duration}
 */
proto.fleet.Duration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.Duration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.Duration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.Duration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.Duration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.fleet.Duration.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.Duration.prototype.setText = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.fleet.Duration.prototype.getValue = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.fleet.Duration.prototype.setValue = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.DirectionsStep = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.DirectionsStep, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.DirectionsStep.displayName = 'proto.fleet.DirectionsStep';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.DirectionsStep.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.DirectionsStep.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.DirectionsStep} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsStep.toObject = function(includeInstance, msg) {
  var f, obj = {
    distance: (f = msg.getDistance()) && proto.fleet.Distance.toObject(includeInstance, f),
    duration: (f = msg.getDuration()) && proto.fleet.Duration.toObject(includeInstance, f),
    endLocation: (f = msg.getEndLocation()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    instructions: jspb.Message.getFieldWithDefault(msg, 4, ""),
    startLocation: (f = msg.getStartLocation()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    travelMode: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.DirectionsStep}
 */
proto.fleet.DirectionsStep.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.DirectionsStep;
  return proto.fleet.DirectionsStep.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.DirectionsStep} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.DirectionsStep}
 */
proto.fleet.DirectionsStep.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.Distance;
      reader.readMessage(value,proto.fleet.Distance.deserializeBinaryFromReader);
      msg.setDistance(value);
      break;
    case 2:
      var value = new proto.fleet.Duration;
      reader.readMessage(value,proto.fleet.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 3:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setEndLocation(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstructions(value);
      break;
    case 6:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setStartLocation(value);
      break;
    case 7:
      var value = /** @type {!proto.fleet.TravelMode} */ (reader.readEnum());
      msg.setTravelMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.DirectionsStep.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.DirectionsStep.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.DirectionsStep} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsStep.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.Distance.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.Duration.serializeBinaryToWriter
    );
  }
  f = message.getEndLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getInstructions();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStartLocation();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getTravelMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional Distance distance = 1;
 * @return {?proto.fleet.Distance}
 */
proto.fleet.DirectionsStep.prototype.getDistance = function() {
  return /** @type{?proto.fleet.Distance} */ (
    jspb.Message.getWrapperField(this, proto.fleet.Distance, 1));
};


/** @param {?proto.fleet.Distance|undefined} value */
proto.fleet.DirectionsStep.prototype.setDistance = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.DirectionsStep.prototype.clearDistance = function() {
  this.setDistance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsStep.prototype.hasDistance = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Duration duration = 2;
 * @return {?proto.fleet.Duration}
 */
proto.fleet.DirectionsStep.prototype.getDuration = function() {
  return /** @type{?proto.fleet.Duration} */ (
    jspb.Message.getWrapperField(this, proto.fleet.Duration, 2));
};


/** @param {?proto.fleet.Duration|undefined} value */
proto.fleet.DirectionsStep.prototype.setDuration = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.DirectionsStep.prototype.clearDuration = function() {
  this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsStep.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LatLngLiteral end_location = 3;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.DirectionsStep.prototype.getEndLocation = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 3));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.DirectionsStep.prototype.setEndLocation = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.fleet.DirectionsStep.prototype.clearEndLocation = function() {
  this.setEndLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsStep.prototype.hasEndLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string instructions = 4;
 * @return {string}
 */
proto.fleet.DirectionsStep.prototype.getInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.DirectionsStep.prototype.setInstructions = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional LatLngLiteral start_location = 6;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.DirectionsStep.prototype.getStartLocation = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 6));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.DirectionsStep.prototype.setStartLocation = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.fleet.DirectionsStep.prototype.clearStartLocation = function() {
  this.setStartLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsStep.prototype.hasStartLocation = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional TravelMode travel_mode = 7;
 * @return {!proto.fleet.TravelMode}
 */
proto.fleet.DirectionsStep.prototype.getTravelMode = function() {
  return /** @type {!proto.fleet.TravelMode} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.fleet.TravelMode} value */
proto.fleet.DirectionsStep.prototype.setTravelMode = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.DirectionsLeg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.DirectionsLeg.repeatedFields_, null);
};
goog.inherits(proto.fleet.DirectionsLeg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.DirectionsLeg.displayName = 'proto.fleet.DirectionsLeg';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.DirectionsLeg.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.DirectionsLeg.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.DirectionsLeg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.DirectionsLeg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsLeg.toObject = function(includeInstance, msg) {
  var f, obj = {
    distance: (f = msg.getDistance()) && proto.fleet.Distance.toObject(includeInstance, f),
    duration: (f = msg.getDuration()) && proto.fleet.Duration.toObject(includeInstance, f),
    startLocation: (f = msg.getStartLocation()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    startAddress: jspb.Message.getFieldWithDefault(msg, 4, ""),
    endLocation: (f = msg.getEndLocation()) && proto.fleet.LatLngLiteral.toObject(includeInstance, f),
    endAddress: jspb.Message.getFieldWithDefault(msg, 6, ""),
    stepsList: jspb.Message.toObjectList(msg.getStepsList(),
    proto.fleet.DirectionsStep.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.DirectionsLeg}
 */
proto.fleet.DirectionsLeg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.DirectionsLeg;
  return proto.fleet.DirectionsLeg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.DirectionsLeg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.DirectionsLeg}
 */
proto.fleet.DirectionsLeg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.Distance;
      reader.readMessage(value,proto.fleet.Distance.deserializeBinaryFromReader);
      msg.setDistance(value);
      break;
    case 2:
      var value = new proto.fleet.Duration;
      reader.readMessage(value,proto.fleet.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 3:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setStartLocation(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartAddress(value);
      break;
    case 5:
      var value = new proto.fleet.LatLngLiteral;
      reader.readMessage(value,proto.fleet.LatLngLiteral.deserializeBinaryFromReader);
      msg.setEndLocation(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndAddress(value);
      break;
    case 7:
      var value = new proto.fleet.DirectionsStep;
      reader.readMessage(value,proto.fleet.DirectionsStep.deserializeBinaryFromReader);
      msg.addSteps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.DirectionsLeg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.DirectionsLeg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.DirectionsLeg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsLeg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistance();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.fleet.Distance.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.Duration.serializeBinaryToWriter
    );
  }
  f = message.getStartLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getStartAddress();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEndLocation();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.fleet.LatLngLiteral.serializeBinaryToWriter
    );
  }
  f = message.getEndAddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStepsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.fleet.DirectionsStep.serializeBinaryToWriter
    );
  }
};


/**
 * optional Distance distance = 1;
 * @return {?proto.fleet.Distance}
 */
proto.fleet.DirectionsLeg.prototype.getDistance = function() {
  return /** @type{?proto.fleet.Distance} */ (
    jspb.Message.getWrapperField(this, proto.fleet.Distance, 1));
};


/** @param {?proto.fleet.Distance|undefined} value */
proto.fleet.DirectionsLeg.prototype.setDistance = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.fleet.DirectionsLeg.prototype.clearDistance = function() {
  this.setDistance(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsLeg.prototype.hasDistance = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Duration duration = 2;
 * @return {?proto.fleet.Duration}
 */
proto.fleet.DirectionsLeg.prototype.getDuration = function() {
  return /** @type{?proto.fleet.Duration} */ (
    jspb.Message.getWrapperField(this, proto.fleet.Duration, 2));
};


/** @param {?proto.fleet.Duration|undefined} value */
proto.fleet.DirectionsLeg.prototype.setDuration = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.DirectionsLeg.prototype.clearDuration = function() {
  this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsLeg.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LatLngLiteral start_location = 3;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.DirectionsLeg.prototype.getStartLocation = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 3));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.DirectionsLeg.prototype.setStartLocation = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.fleet.DirectionsLeg.prototype.clearStartLocation = function() {
  this.setStartLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsLeg.prototype.hasStartLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string start_address = 4;
 * @return {string}
 */
proto.fleet.DirectionsLeg.prototype.getStartAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.DirectionsLeg.prototype.setStartAddress = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional LatLngLiteral end_location = 5;
 * @return {?proto.fleet.LatLngLiteral}
 */
proto.fleet.DirectionsLeg.prototype.getEndLocation = function() {
  return /** @type{?proto.fleet.LatLngLiteral} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngLiteral, 5));
};


/** @param {?proto.fleet.LatLngLiteral|undefined} value */
proto.fleet.DirectionsLeg.prototype.setEndLocation = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.fleet.DirectionsLeg.prototype.clearEndLocation = function() {
  this.setEndLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsLeg.prototype.hasEndLocation = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string end_address = 6;
 * @return {string}
 */
proto.fleet.DirectionsLeg.prototype.getEndAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.fleet.DirectionsLeg.prototype.setEndAddress = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated DirectionsStep steps = 7;
 * @return {!Array<!proto.fleet.DirectionsStep>}
 */
proto.fleet.DirectionsLeg.prototype.getStepsList = function() {
  return /** @type{!Array<!proto.fleet.DirectionsStep>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.DirectionsStep, 7));
};


/** @param {!Array<!proto.fleet.DirectionsStep>} value */
proto.fleet.DirectionsLeg.prototype.setStepsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.fleet.DirectionsStep=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.DirectionsStep}
 */
proto.fleet.DirectionsLeg.prototype.addSteps = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fleet.DirectionsStep, opt_index);
};


proto.fleet.DirectionsLeg.prototype.clearStepsList = function() {
  this.setStepsList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.DirectionsRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.DirectionsRoute.repeatedFields_, null);
};
goog.inherits(proto.fleet.DirectionsRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.DirectionsRoute.displayName = 'proto.fleet.DirectionsRoute';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.DirectionsRoute.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.DirectionsRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.DirectionsRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.DirectionsRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bounds: (f = msg.getBounds()) && proto.fleet.LatLngBounds.toObject(includeInstance, f),
    legsList: jspb.Message.toObjectList(msg.getLegsList(),
    proto.fleet.DirectionsLeg.toObject, includeInstance),
    overviewPolyline: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.DirectionsRoute}
 */
proto.fleet.DirectionsRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.DirectionsRoute;
  return proto.fleet.DirectionsRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.DirectionsRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.DirectionsRoute}
 */
proto.fleet.DirectionsRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 2:
      var value = new proto.fleet.LatLngBounds;
      reader.readMessage(value,proto.fleet.LatLngBounds.deserializeBinaryFromReader);
      msg.setBounds(value);
      break;
    case 3:
      var value = new proto.fleet.DirectionsLeg;
      reader.readMessage(value,proto.fleet.DirectionsLeg.deserializeBinaryFromReader);
      msg.addLegs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverviewPolyline(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.DirectionsRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.DirectionsRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.DirectionsRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBounds();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.fleet.LatLngBounds.serializeBinaryToWriter
    );
  }
  f = message.getLegsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.fleet.DirectionsLeg.serializeBinaryToWriter
    );
  }
  f = message.getOverviewPolyline();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string summary = 1;
 * @return {string}
 */
proto.fleet.DirectionsRoute.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRoute.prototype.setSummary = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LatLngBounds bounds = 2;
 * @return {?proto.fleet.LatLngBounds}
 */
proto.fleet.DirectionsRoute.prototype.getBounds = function() {
  return /** @type{?proto.fleet.LatLngBounds} */ (
    jspb.Message.getWrapperField(this, proto.fleet.LatLngBounds, 2));
};


/** @param {?proto.fleet.LatLngBounds|undefined} value */
proto.fleet.DirectionsRoute.prototype.setBounds = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.fleet.DirectionsRoute.prototype.clearBounds = function() {
  this.setBounds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.fleet.DirectionsRoute.prototype.hasBounds = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated DirectionsLeg legs = 3;
 * @return {!Array<!proto.fleet.DirectionsLeg>}
 */
proto.fleet.DirectionsRoute.prototype.getLegsList = function() {
  return /** @type{!Array<!proto.fleet.DirectionsLeg>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.DirectionsLeg, 3));
};


/** @param {!Array<!proto.fleet.DirectionsLeg>} value */
proto.fleet.DirectionsRoute.prototype.setLegsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.fleet.DirectionsLeg=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.DirectionsLeg}
 */
proto.fleet.DirectionsRoute.prototype.addLegs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fleet.DirectionsLeg, opt_index);
};


proto.fleet.DirectionsRoute.prototype.clearLegsList = function() {
  this.setLegsList([]);
};


/**
 * optional string overview_polyline = 4;
 * @return {string}
 */
proto.fleet.DirectionsRoute.prototype.getOverviewPolyline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRoute.prototype.setOverviewPolyline = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.DirectionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fleet.DirectionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.DirectionsRequest.displayName = 'proto.fleet.DirectionsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.DirectionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.DirectionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.DirectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: jspb.Message.getFieldWithDefault(msg, 1, ""),
    origin: jspb.Message.getFieldWithDefault(msg, 2, ""),
    destination: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    alternatives: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.DirectionsRequest}
 */
proto.fleet.DirectionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.DirectionsRequest;
  return proto.fleet.DirectionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.DirectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.DirectionsRequest}
 */
proto.fleet.DirectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrigin(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestination(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.DirectionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.DirectionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.DirectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrigin();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDestination();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAlternatives();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string language = 1;
 * @return {string}
 */
proto.fleet.DirectionsRequest.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRequest.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string origin = 2;
 * @return {string}
 */
proto.fleet.DirectionsRequest.prototype.getOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRequest.prototype.setOrigin = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string destination = 3;
 * @return {string}
 */
proto.fleet.DirectionsRequest.prototype.getDestination = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRequest.prototype.setDestination = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mode = 4;
 * @return {string}
 */
proto.fleet.DirectionsRequest.prototype.getMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRequest.prototype.setMode = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string alternatives = 5;
 * @return {string}
 */
proto.fleet.DirectionsRequest.prototype.getAlternatives = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.fleet.DirectionsRequest.prototype.setAlternatives = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fleet.DirectionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fleet.DirectionsResponse.repeatedFields_, null);
};
goog.inherits(proto.fleet.DirectionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.fleet.DirectionsResponse.displayName = 'proto.fleet.DirectionsResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fleet.DirectionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fleet.DirectionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fleet.DirectionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet.DirectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    proto.fleet.DirectionsRoute.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet.DirectionsResponse}
 */
proto.fleet.DirectionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fleet.DirectionsResponse;
  return proto.fleet.DirectionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet.DirectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet.DirectionsResponse}
 */
proto.fleet.DirectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fleet.DirectionsRoute;
      reader.readMessage(value,proto.fleet.DirectionsRoute.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fleet.DirectionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fleet.DirectionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet.DirectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fleet.DirectionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fleet.DirectionsRoute.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DirectionsRoute routes = 1;
 * @return {!Array<!proto.fleet.DirectionsRoute>}
 */
proto.fleet.DirectionsResponse.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.fleet.DirectionsRoute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fleet.DirectionsRoute, 1));
};


/** @param {!Array<!proto.fleet.DirectionsRoute>} value */
proto.fleet.DirectionsResponse.prototype.setRoutesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fleet.DirectionsRoute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet.DirectionsRoute}
 */
proto.fleet.DirectionsResponse.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet.DirectionsRoute, opt_index);
};


proto.fleet.DirectionsResponse.prototype.clearRoutesList = function() {
  this.setRoutesList([]);
};


/**
 * @enum {number}
 */
proto.fleet.TravelMode = {
  BICYCLING: 0,
  DRIVING: 1,
  TRANSIT: 2,
  TWO_WHEELER: 3,
  WALKING: 4
};

goog.object.extend(exports, proto.fleet);
